import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
    spacing40,
    spacing50,
} from '@ellucian/react-design-system/core/styles/tokens';
import {
    Typography,
    makeStyles
} from '@ellucian/react-design-system/core';

const useStyles = makeStyles(() => ({
    content: {
        display: 'grid',
        gridTemplateColumns: 'max-content max-content',
        gridColumnGap: spacing50,
    },
    labelDiv: {
        display: 'flex',
    },
    labelText: {
        paddingRight: spacing40,
    },
}));

const AppDesignerSidebarDialogHeader = props => {
    const { controlType, controlLabel = '' } = props;
    const classes = useStyles();

    return (
        <div className={classes.content}>
            <div className={classes.labelDiv}>
                <Typography className={classes.labelText}>
                    <strong><FormattedMessage id="appDesignSidebarDialogHeaderControlTypeLabel" /></strong>
                </Typography>
                <Typography className={classes.labelText}>
                    <FormattedMessage id={`appDesignSidebarDialogHeaderControlType${controlType}`} />
                </Typography>
            </div>
            <div className={classes.labelDiv}>
                <Typography className={classes.labelText}>
                    <strong><FormattedMessage id="appDesignSidebarDialogHeaderControlNameLabel" /></strong>
                </Typography>
                <Typography>
                    {controlLabel}
                </Typography>
            </div>
        </div>
    );
};

AppDesignerSidebarDialogHeader.propTypes = {
    controlType: PropTypes.string.isRequired,
    controlLabel: PropTypes.string,
};

export default AppDesignerSidebarDialogHeader;
